import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn, FormGroup } from '@angular/forms';
import { SelfcorrectingService } from './selfcorrecting.service';

export function MinimalDistanceValidator(selfcorrectingService: SelfcorrectingService): ValidatorFn {
  return (control: FormGroup): { [key: string]: any } => {
    const distance = control.get('minimalDistance');
    if(!distance){
      return null;
    }
    let value = distance.value;

    let givenCodes:string[] = [];
    let lastvalue = control.get('givenCodes0');
    let i = 1;
    while(lastvalue){
      givenCodes.push(lastvalue.value);
      lastvalue = control.get('givenCodes'+i.toString());
      i++;
    }
  
    if (!givenCodes || givenCodes.length < 2) {
      return null;
    }
    
    if (selfcorrectingService.minDistance(givenCodes.filter(v => v).filter(v => v.length > 0)) < value) {
      return { 'appMinimalDistance': { value: givenCodes } }
    }
    return null;
  };
}

@Directive({
  selector: '[appMinimalDistance]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinimalDistanceDirective, multi: true }]
})
export class MinimalDistanceDirective implements Validator{

  //@Input('appMinimalDistance') givenCodes: string[];

  constructor(protected selfcorrectingService: SelfcorrectingService) {
  }
  validate(control: FormGroup): { [key: string]: any } {
    return MinimalDistanceValidator(this.selfcorrectingService)(control)
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

 ngOnChanges(changes: SimpleChanges): void {
 
    if ('givenCodes' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

}
